import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule, HEADER_CONFIG } from './app/app.module';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfiguration,
} from './environments/models/environment.model';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

void fetch('./assets/environment-config.json')
  .then((resp) => resp.json())
  .then((config: EnvironmentConfiguration) => {
    // Check if the "Authorization" cookie exists
    const hasAuthorizationCookie = document.cookie
      .split(';')
      .some((cookie) => cookie.trim().startsWith('Authorization='));

    platformBrowserDynamic([
      { provide: ENVIRONMENT_CONFIG, useValue: config },
      {
        provide: HEADER_CONFIG,
        useValue: {
          redirectUri: config.oAuth.redirectURL,
          postLogoutRedirectUri: config.oAuth.postLogoutRedirectURL,
          clientId: config.oAuth.clientId,
          authority: config.oAuth.authority,
          authorityDomain: config.oAuth.authorityDomain,
          portalURL: config.portal.redirectURL,
          authConfigUrls: hasAuthorizationCookie
            ? new Map()
            : new Map(
                [config.serviceCall.baseURL].map((url) => [
                  url,
                  ['openid', 'offline_access', 'email', config.oAuth.clientId],
                ]) ?? [],
              ),
        },
      },
    ])
      .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
      })
      .catch((err) => console.error(err));
  });
